import { faChevronLeft, faPrint } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { useState } from "react";
import { sxDarkGreyBody, sxSubTitle } from "../../../../../assets/styles/CommonSxProps";
import LoadingApp from "../../../../../components/LoadingApp";
import { StepFinalizacaoProps } from "../../../../../interfaces/props/Cancelamento/StepFinalizacaoProps";
import { gerarRelatSolicExclUsr } from "../../../../../services/RelatorioService";
import { base64toBlob } from "../../../../../utils/Base64ToBlob";
import CancelledBenefsTable from "./CancelledBenefsTable";
import './styles.css';
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import moment from "moment";

const StepFinalizacao: React.FC<StepFinalizacaoProps> = ({ protocolo, cancelledBenefs, backStep }) => {

  const [loading, setLoading] = useState<boolean>(false);

  const { textStyleAccessibility } = useAccessibility();

  const printCheckingCopy = async () => {
    setLoading(true);
    const response = await gerarRelatSolicExclUsr(protocolo);
    if (response?.data) {
      const pdf = response.data.dados.conteudo;
      const blob = base64toBlob(pdf);
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    }
    setLoading(false);
  }

  return (
    <>
      <LoadingApp showLoading={loading} text={'Gerando comprovante...'} />
      <div className="motivo-cancelamento-container">
        <Typography sx={sxSubTitle}>
          Solicitação de cancelamento realizada com sucesso!
        </Typography>
        <Typography sx={sxDarkGreyBody}>
          <b>Protocolo:</b> {protocolo}
        </Typography>
        <Typography sx={sxDarkGreyBody}>
          Beneficiário(s) excluído(s) do contrato: 
        </Typography>
        <CancelledBenefsTable data={cancelledBenefs} />
        <div className='cancellation-advice-container'>
          <Typography sx={sxSubTitle}>
            O plano permanece ativo até às 23:59 do dia de hoje ({moment().format('DD/MM/YYYY')}).
          </Typography>
          <Typography sx={sxDarkGreyBody}>
            Clique a seguir para imprimir ou salvar em PDF o comprovante da sua solicitação com o resumo de todos os dados.
          </Typography>
        </div>
        <div className='cancellation-buttons-container'>
          <button
            onClick={printCheckingCopy}
            className="print-button"
          >
            <FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;<u>Imprimir comprovante</u>
          </button>
          <button className="back-button"
            onClick={backStep}
            style={{...textStyleAccessibility}}
            aria-label="Voltar para termos do cancelamento"
          >
            <FontAwesomeIcon style={textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </div>
      </div>
    </>
  );
}

export default StepFinalizacao;